module.exports = __webpack_public_path__ + "img/flirt.8439236.png";